import React from 'react';
import { Building2, Clock } from 'lucide-react';
import { useLanguage } from '../../i18n/LanguageContext';
export function SocialProofSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 bg-[#EDE7F6]" data-id="element-222">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-223">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-center" data-id="element-224">
          <div className="flex flex-col items-center" data-id="element-225">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-[#7C4DFF] mb-6 shadow-sm" data-id="element-226">
              <Building2 size={32} data-id="element-227" />
            </div>
            <div className="text-6xl font-bold text-[#7C4DFF] mb-2" data-id="element-228">20+</div>
            <p className="text-xl text-gray-600 font-medium" data-id="element-229">
              {t('social.gardens')}
            </p>
          </div>

          <div className="flex flex-col items-center" data-id="element-230">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-[#7C4DFF] mb-6 shadow-sm" data-id="element-231">
              <Clock size={32} data-id="element-232" />
            </div>
            <div className="text-6xl font-bold text-[#7C4DFF] mb-2" data-id="element-233">28.8</div>
            <p className="text-xl text-gray-600 font-medium" data-id="element-234">
              {t('social.hours')}
            </p>
          </div>
        </div>
      </div>
    </section>;
}